import React, {useContext} from "react";
import "./StudentOpportunities.css";
import {studentOpportunities} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function StudentOpportunities() {
  const {isDark} = useContext(StyleContext);
  
  function openLinkInNewWindow(url) {
    var win = window.open(url, "_blank");
    win.focus();
  }
  
  if (!studentOpportunities.display) {
    return null;
  }
  
  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="student-opportunities">
        <div>
          <h1 className="skills-heading">{studentOpportunities.title}</h1>
          <p
            className={
              isDark
                ? "dark-mode project-subtitle"
                : "subTitle project-subtitle"
            }
          >
            {studentOpportunities.subtitle}
          </p>

          <div className="opportunities-container">
            {studentOpportunities.opportunities.map((opportunity, i) => {
              return (
                <div
                  key={i}
                  className={
                    isDark
                      ? "dark-mode opportunity-card opportunity-card-dark"
                      : "opportunity-card opportunity-card-light"
                  }
                >
                  <div className="opportunity-header">
                    <h3
                      className={isDark ? "dark-mode opportunity-level" : "opportunity-level"}
                    >
                      {opportunity.level}
                    </h3>
                  </div>

                  <div className="opportunity-detail">
                    <p
                      className={
                        isDark ? "dark-mode opportunity-description" : "opportunity-description"
                      }
                    >
                      {opportunity.description}
                    </p>

                    {opportunity.highlight && (
                      <p className="opportunity-highlight">
                        {opportunity.highlight}
                      </p>
                    )}

                    {opportunity.importantNote && (
                      <p className="opportunity-important-note">
                        {opportunity.importantNote}
                      </p>
                    )}

                    <div className="opportunity-meta">
                      <div className="meta-item">
                        <span className="meta-label">Duration:</span>
                        <span className={isDark ? "dark-mode meta-value" : "meta-value"}>
                          {opportunity.duration}
                        </span>
                      </div>
                      <div className="meta-item">
                        <span className="meta-label">Requirements:</span>
                        <span className={isDark ? "dark-mode meta-value" : "meta-value"}>
                          {opportunity.requirements}
                        </span>
                      </div>
                    </div>

                    {opportunity.actionLinks && (
                      <div className="action-links-container">
                        {opportunity.actionLinks.map((link, linkIndex) => (
                          <button
                            key={linkIndex}
                            className={isDark ? "dark-mode action-link-btn" : "action-link-btn"}
                            onClick={() => openLinkInNewWindow(link.url)}
                          >
                            {link.name}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Fade>
  );
}
